import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20collage%20with%20vibrant%20comic%20panels%2C%20warm%20amber%20and%20coral%20toned%20abstract%20gradient%20background%2C%20ink%20splash%20effects%2C%20manga%20reading%20aesthetic%2C%20artistic%20composition%2C%20soft%20dramatic%20lighting%2C%20cinematic%20feel&width=1600&height=900&seq=hero-bg-korean-manhwa&orientation=landscape"
        alt="韩国漫画网 - 好看的韩国漫画在线阅读"
        title="韩国漫画网 - 韩漫在线免费阅读"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-full mb-4">
              韩漫大全 · 每日更新
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 font-heading">
              发现最<strong className="text-accent-300 font-bold">好看</strong>的韩国漫画
            </h1>
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-lg">
              热门韩漫作品一网打尽，海量精选漫画免费在线阅读。每日更新最新章节，给您流畅沉浸的阅读体验。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/all"
                className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer"
              >
                立即开始阅读
              </Link>
              <Link
                to="/category/completed"
                className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg hover:bg-background-50/25 transition-all text-sm border border-background-50/20 whitespace-nowrap cursor-pointer"
              >
                查看已完结作品
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-background-50">1000+</span>
                <span className="text-xs text-background-50/60">漫画作品</span>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-background-50">50万+</span>
                <span className="text-xs text-background-50/60">活跃读者</span>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-background-50">每日</span>
                <span className="text-xs text-background-50/60">更新不断</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}